import { Grid, GridColumn, GridToolbar } from '@progress/kendo-react-grid'
import { Card, CardBody, GridLayout, GridLayoutItem } from '@progress/kendo-react-layout'
import { DatePicker } from '@progress/kendo-react-dateinputs'

const dataConstPeriod = [
  { usage: '前工期', rc1: '', rc2: '', src1: '', src2: '', s1: '', s2: '', pc1: '20', pc2: '27', travis1: '20', travis2: '29', inEdit: true },
  { usage: '構真柱', rc1: '', rc2: '', src1: '', src2: '', s1: '', s2: '', pc1: '', pc2: '', travis1: '', travis2: '', inEdit: true },
  { usage: '先行底躯体', rc1: '', rc2: '', src1: '', src2: '', s1: '', s2: '', pc1: '8', pc2: '', travis1: '8', travis2: '', inEdit: true },
  { usage: '掘削', rc1: '', rc2: '', src1: '', src2: '', s1: '', s2: '', pc1: '4', pc2: '', travis1: '4', travis2: '', inEdit: true },
  { usage: '地下躯体１', rc1: '', rc2: '', src1: '', src2: '', s1: '', s2: '', pc1: '12', pc2: '', travis1: '12', travis2: '', inEdit: true },
  { usage: '基礎', rc1: '', rc2: '', src1: '', src2: '', s1: '', s2: '', pc1: '6', pc2: '', travis1: '6', travis2: '', inEdit: true },
  { usage: '地下鉄骨', rc1: '', rc2: '', src1: '', src2: '', s1: '', s2: '', pc1: '', pc2: '', travis1: '', travis2: '', inEdit: true },
  { usage: '地下躯体２', rc1: '', rc2: '', src1: '', src2: '', s1: '', s2: '', pc1: '8', pc2: '', travis1: '8', travis2: '', inEdit: true },
  { usage: '地上', rc1: '', rc2: '', src1: '', src2: '', s1: '', s2: '', pc1: '', pc2: '42', travis1: '', travis2: '39', inEdit: true },
  { usage: '地上鉄骨１', rc1: '', rc2: '', src1: '', src2: '', s1: '', s2: '', pc1: '', pc2: '', travis1: '', travis2: '', inEdit: true },
  { usage: '地上躯体', rc1: '', rc2: '', src1: '', src2: '', s1: '', s2: '', pc1: '', pc2: '', travis1: '', travis2: '', inEdit: true },
  { usage: '地上鉄骨２', rc1: '', rc2: '', src1: '', src2: '', s1: '', s2: '', pc1: '', pc2: '', travis1: '', travis2: '', inEdit: true },
  { usage: '後工期', rc1: '', rc2: '', src1: '', src2: '', s1: '', s2: '', pc1: '42', pc2: '31', travis1: '42', travis2: '32', inEdit: true },
  { usage: '全体', rc1: '', rc2: '', src1: '', src2: '', s1: '', s2: '', pc1: '100', pc2: '100', travis1: '100', travis2: '100', inEdit: true }
]

export default function ConstPeriodSettingReverse() {
  return (
    <div>
      <Card style={{ margin: 6 }}>
        <CardBody>
          <GridLayout>
            <GridLayoutItem col={1} style={{ textAlign: 'center', marginTop: '3px' }}>
              適用開始日
            </GridLayoutItem>
            <GridLayoutItem col={2}>
              <DatePicker />
            </GridLayoutItem>
          </GridLayout>
        </CardBody>
      </Card>

      <div style={{ display: 'grid' }}>
        <div style={{ gridColumn: 1, margin: '0px 5px 0px 5px' }}>
          <Grid data={dataConstPeriod} editField="inEdit">
            <GridToolbar>工期設定</GridToolbar>
            <GridColumn title="地上構造" field="usage" editable={false} />
            <GridColumn title="RC">
              <GridColumn title="RC1" field="rc1" />
              <GridColumn title="RC2" field="rc2" />
            </GridColumn>
            <GridColumn title="SRC">
              <GridColumn title="SRC1" field="src1" />
              <GridColumn title="SRC2" field="src2" />
            </GridColumn>
            <GridColumn title="S">
              <GridColumn title="S1" field="s1" />
              <GridColumn title="S2" field="s2" />
            </GridColumn>
            <GridColumn title="PC">
              <GridColumn title="PC1" field="pc1" />
              <GridColumn title="PC2" field="pc2" />
            </GridColumn>
            <GridColumn title="トラビス">
              <GridColumn title="トラビス1" field="travis1" />
              <GridColumn title="トラビス2" field="travis2" />
            </GridColumn>
          </Grid>
        </div>
      </div>
    </div>
  )
}
